import { render, staticRenderFns } from "./SaldosPorCierre.vue?vue&type=template&id=61965d22"
import script from "./SaldosPorCierre.vue?vue&type=script&lang=js"
export * from "./SaldosPorCierre.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports